// Viewer-facing words for the table's state, shared by the site and the OBS
// overlay. Everything here reads the public table snapshot only.
const TIMED = ['LOTTERY', 'CONFIRMATION', 'BETTING', 'LAST_CALL', 'LOCKED']

function shooterName (table) {
  const hand = table && table.hand
  return hand && hand.shooter && hand.shooter.kind === 'player' && hand.shooter.displayName ? hand.shooter.displayName : null
}

function houseShooting (table) {
  const hand = table && table.hand
  return !!(hand && hand.shooter && hand.shooter.kind === 'house')
}

export function timerState (table, now, serverOffset) {
  if (!table || TIMED.indexOf(table.phase) === -1 || !table.deadlineAt) return { active: false, seconds: 0, fraction: 0 }
  const clock = now + (serverOffset || 0)
  const deadline = Date.parse(table.deadlineAt)
  const started = table.phaseStartedAt ? Date.parse(table.phaseStartedAt) : deadline - 1000
  const total = Math.max(1000, deadline - started)
  const remaining = Math.max(0, deadline - clock)
  return { active: true, seconds: Math.ceil(remaining / 1000), fraction: Math.max(0, Math.min(1, remaining / total)) }
}

export function statusMessage (table, now, serverOffset) {
  if (!table) return 'Connecting to the table…'
  const name = shooterName(table)
  const point = table.hand ? table.hand.point : null
  const timer = timerState(table, now, serverOffset)
  switch (table.phase) {
    case 'STOPPED': return 'The table is closed right now.'
    case 'RECOVERY_PAUSED': return 'Table paused — an operator is checking things.'
    case 'PREPARED': return 'Shuffling up a new hand…'
    case 'LOTTERY': return 'Shooter lottery and bets are open — who wants to roll?'
    case 'CONFIRMATION': return (name || 'The winner') + ' was picked to shoot — waiting for them to step up!'
    case 'BETTING':
    case 'LAST_CALL': return point ? 'Bets are open! ' + (name || 'The house') + ' is shooting for the ' + point + '.' : 'Place your bets! ' + (name || 'The house') + ' is coming out.'
    case 'LOCKED': return houseShooting(table) ? 'Bets are closed — the house rolls in ' + timer.seconds + ' seconds!' : 'Bets are closed, ' + (name || 'the shooter') + ' rolls in ' + timer.seconds + ' seconds!'
    case 'RESOLVING': return 'Dice are down — settling bets…'
    case 'BETWEEN_HANDS': return 'Hand over! Next shooter coming up.'
    default: return String(table.phase || '').replace(/_/g, ' ').toLowerCase().replace(/^./, c => c.toUpperCase()) || 'Connecting to the table…'
  }
}

export function actionTip (table) {
  if (!table) return ''
  const name = shooterName(table)
  const point = table.hand ? table.hand.point : null
  switch (table.phase) {
    case 'STOPPED':
    case 'RECOVERY_PAUSED': return 'Play at swiftorland.com/#/craps when the table reopens.'
    case 'PREPARED': return 'New hand coming — type !roll when the lottery opens!'
    case 'LOTTERY': return !table.deadlineAt ? 'Type !roll to enter — no wager required! The first entry starts the countdown.' : 'Type !roll to enter before the countdown ends — no wager required!'
    case 'CONFIRMATION': return (name || 'Shooter') + ': say anything in chat to roll now — your words become your shout!'
    case 'BETTING':
    case 'LAST_CALL': return point ? 'Type !odds 100 to bet that ' + point + ' is rolled before 7!' : 'Type !pass 100 to bet on the next ON number!'
    case 'LOCKED': return (name || 'Shooter') + ': type !roll now, or the dice roll automatically when the timer ends.'
    case 'RESOLVING': return 'Settling up… the next bets open in a moment.'
    case 'BETWEEN_HANDS': return 'New hand coming — type !roll when the lottery opens!'
    default: return ''
  }
}



// WEBPACK FOOTER //
// ./src/lib/craps-copy.js